const apiDomain = '';

export default {
    getSmileTypes: `${apiDomain}/api/smile/type`,
    getSmileScore: `${apiDomain}/api/smile/score`,
    getSmileImage: `${apiDomain}/api/smile/image`,
    getCounty: `${apiDomain}/api/county`,
    getDistrict: `${apiDomain}/api/district/?county_id=`,
    createUserInfo: `${apiDomain}/api/smile/user`,
};
